import { lazy, type ComponentType } from 'react';

/**
 * Una pantalla que se baja al abrirla. Si el archivo ya no existe (se publicó una versión nueva mientras la web estaba
 * abierta), recarga la página una vez para traer la versión nueva en lugar de quedarse en blanco.
 */
export function perezoso<M extends Record<string, unknown>>(cargar: () => Promise<M>, nombre: keyof M & string) {
  return lazy(async () => {
    try {
      const m = await cargar();
      try { sessionStorage.removeItem('igor-recarga-version'); } catch { /* nada */ }
      return { default: m[nombre] as ComponentType<Record<string, never>> };
    } catch (e) {
      const clave = 'igor-recarga-version';
      try {
        if (!sessionStorage.getItem(clave)) {
          sessionStorage.setItem(clave, '1');
          location.reload();
          return { default: (() => null) as ComponentType<Record<string, never>> };
        }
      } catch { /* sin almacenamiento: se muestra el error */ }
      throw e;
    }
  });
}
